import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-backendtester',
  templateUrl: './backendtester.component.html',
  styleUrls: ['./backendtester.component.css']
})
export class BackendtesterComponent extends BaseComponent implements OnInit {
  testlog: any = [];
  testrecord: any = {};
  correct = false;
  controller = "";
  action = "";

  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
  }

  async get(controller: string, action: string, query: any, test: string) {
    let result = await this.db.get(controller, action, query);
    return this.finishTestCall(controller, action, test, result);
  }

  async post(controller: string, action: string, body: any, query: any, test: string) {
    let result = await this.db.post(controller, action, body, query);
    return this.finishTestCall(controller, action, test, result);
  }
  async put(controller: string, action: string, body: any, query: any, test: string) {
    let result = await this.db.put(controller, action, body, query);
    return this.finishTestCall(controller, action, test, result);
  }

  async delete(controller: string, action: string, query: any, test: string) {
    let result = await this.db.delete(controller, action, query);
    return this.finishTestCall(controller, action, test, result);
  }

  finishTestCall(controller: string, action: string, test: string, result: any) {
    this.testrecord = { controller, action, test, result };
    this.testlog.push(this.testrecord);
    return result;
  }


  async startTest() {
    this.testlog = [];

    // Controller Sensor -------------------------------------------
    const sensor_getSensors = await this.get("Sensor", "getSensors", null, "Get all Sensors");

    let sensor = sensor_getSensors.find((x: any) => { x.name == "testsensor" })
    if (sensor != null) await this.db.delete("Sensor", "deleteSensor", { id: sensor.id })

    sensor = { id: 0, name: "testsensor", description: "some description" }
    const sensor_postsensor = await this.post("sensor", "postSensor", sensor, null, "Post new Sensor")

    const sensor_deleteSensor = await this.delete("sensor", "deleteSensor", { id: sensor_postsensor.id }, "Delete Sensor")

    // Controller Scenario ------------------------------------------------------------------------
    const Scen_getSchenarios = await this.get("Scenario", "getScenarios", null, "Get all scenarios")

    let scen = Scen_getSchenarios.find((x: any) => { x.name == "TestScenario" })
    if (scen != null) await this.db.delete("Scenario", "deleteScenario", { id: scen.id });
    scen = { id: 0, name: "TestScenario", organizationId: 1, description: "description", geometryJson: "geometry" }
    const Scen_postScenario = await this.post("Scenario", "postScenario", scen, null, "Add Scenario")
    const Scen_getScenario = await this.get("Scenario", "getScenario", { id: Scen_postScenario.id }, "Get test scenario")
    Scen_postScenario.description = "new description"
    const Scen_postScenario2 = await this.post("Scenario", "postScenario", Scen_postScenario, null, "UpdateScenario")
    const Scen_deleteScenario = await this.delete("Scenario", "deleteScenario", { id: Scen_postScenario.id }, "delete scenario")

    // Controller Organization ---------------------------------------------------------------------
    const Org_getOrganizations = await this.get("Organization", "getOrganizations", null, "Get Organizations");

    let org = Org_getOrganizations.find((x: any) => { x.name == "TestOrganization" })
    if (org != null) await this.db.delete("Organization", "deleteOrganization", { id: org.id })

    org = { id: 0, name: "TestOrganization", abreviation: "Ar" }
    const Org_postOrganization = await this.post("Organization", "postOrganization", org, null, "Add an organization")
    const Org_deleteOrganization = await this.delete("organization", "deleteOrganization", { id: Org_postOrganization.id }, "Delete organization")

    // Controller  Beacon ------------------------------------------------------------------
    const Beacon_getBeacons = await this.get("Beacon", "getBeacons", null, "Get all Beacons")

    let beacon = Beacon_getBeacons.find((x: any) => x.uid == "asasasasasas")
    if (beacon != null) await this.db.delete("Beacon", "deleteBeacon", { id: beacon.id })

    beacon = { id: 0, Uid: "asasasasasas", name: "testbeacon", organizationId: 1, comment: "some test comment" }
    const Beacon_addBeacon = await this.post("beacon", "postBeacon", beacon, null, "Add a beacon")
    const Beacon_deleteBeacon = await this.delete("beacon", "deleteBeacon", { id: Beacon_addBeacon.id }, "Delete Beacon")


    // Controller Role -------------------------------------------
    const Role_getRoles = await this.get("Role", "getRoles", null, "Get all Roles");

    const role = Role_getRoles.find((x: any) => x.name == "TestRole"); //just in case
    if (role != null) await this.db.delete("Role", "deleteRole", { Id: role.id });

    const Role_addRole = await this.post("Role", "addRole", null, { RoleName: "TestRole" }, "Add a role");
    const Role_deleteRole = await this.delete("Role", "deleteRole", { Id: Role_addRole.id }, "Delete TestRole");

    // Controller Authenticate --------------------------------------------
    const Auth_getAllUsers = await this.get("Authenticate", "getAllUsers", null, "Get all users");

    let john = Auth_getAllUsers.find((x: any) => x.email == "john.doe@yahoo.com"); // check whether john doe is there
    if (john != null) await this.db.delete("Authenticate", "DeleteUser", { Id: john.id });

    let userjohn: any = { Id: 0, Username: "john.doe@yahoo.com", Email: "john.doe@yahoo.com", Password: "AAABbbc5!", FirstName: "John", LastName: "Doe", Phone: "999 999 9999" };
    const Auth_register = await this.post("Authenticate", "register", userjohn, null, "Create new user john")
    const Auth_getSingleUser = await this.get("Authenticate", "getSingleUser", { Id: Auth_register.id }, "Get single user john")
    let useranna = { Id: Auth_getSingleUser.id, FirstName: "Anna", LastName: "Clara", Phone: "2223332222" }
    const Auth_updateUserInfo = await this.put("Authenticate", "updateUserInfo", null, useranna, "Change user John to Anna")
    const Auth_changePassword = await this.put("Authenticate", "changePassword", null, { Id: Auth_getSingleUser.id, Password: "AAbb55!!!!" }, "Change  Password for Anna")
    const Auth_deleteUser = await this.delete("Authenticate", "deleteUser", { Id: Auth_getSingleUser.id }, "Delete Anna")




    // End of Testing -------------------------------------------------------
    this.testlog.push({ test: "End of testing", result: "Finished", success: true });
  }



}
